import PropTypes from 'prop-types';
import { memo } from 'react';
/**
 * The shared HTML for the "your cart is full" notification, used in both a
 * standalone page (see fullCartMain.js etc.) and in FullCartLightbox.
 *
 * @param fullPage True if this is going to be the standalone content on a page. Needed for CSS purposes.
 * @returns {JSX.Element}
 * @constructor
 */
export let FullCart = function ({ fullPage }) {
    const extraClass = fullPage ? 'page' : 'modal';

    return (
        <div className={`fullCart ${extraClass}`}>
            <img src="/images/cart/full-cart.png" alt="Thank you!"/>
            <h2>Place your donation to continue giving</h2>

            <p>Your cart is full as you've hit the 25 project limit (you’re amazing)! Check out your current cart in order to add new projects.</p>

            <a href={`${secureBaseURL}donors/givingCart.html`} className="button-primary">Check out now</a>
        </div>
    );
};
FullCart.propTypes = {
    fullPage: PropTypes.bool,
};
FullCart = memo(FullCart);
